// custom-currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number, currencyCode: string = 'USD', _display: 'code' | 'symbol' | 'symbol-narrow' = 'symbol'): string {
    if (value == null) return '';

    const hasDecimal = value % 1 !== 0;
    const options: Intl.NumberFormatOptions = {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: hasDecimal ? 2 : 0,
      maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat('en-US', options).format(value);
  }
}
